var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "photo-lower-bar-button-group" }, [
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.changeScale()
          }
        }
      },
      [
        _c("SVGRuler", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Изменить масштаб")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.activeStep === "planeCategoriesForPerspectiveActivePlane",
            expression:
              "activeStep === 'planeCategoriesForPerspectiveActivePlane'"
          }
        ],
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.changePerspective()
          }
        }
      },
      [
        _c("SVGStepsPerspective", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Настроить перспективу")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }